import { Injectable, inject } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { Observable, combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AppState } from '../../model/reducer';
import { isAuthDoneView, isAuthenticatedView } from '../../model/views';
import { NavigationService } from '../../navbar/navigation.service';

@Injectable()
export class LoginGuard  {
  private store$ = inject<Store<AppState>>(Store);
  private navigationService = inject(NavigationService);


  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return combineLatest([
      this.store$.pipe(select(isAuthenticatedView)),
      this.store$.pipe(select(isAuthDoneView))]
    ).pipe(
      filter(([_isAuthenticated, isAuthDone]) => isAuthDone),
      map(([isAuthenticated]) => {
        if (isAuthenticated) {
          setTimeout(() => this.navigationService.navigateToReturnUrl());
        }
        return !isAuthenticated;
      })
    );
  }
}
